import React, { useEffect } from 'react';
import { Phone } from 'lucide-react';
import WebForm from '../components/WebForm';
import { BRAND } from '../mock';
import useReveal from '../hooks/useReveal';

export default function Quote() {
  useReveal();
  useEffect(() => { document.title = 'Get a Quote | StreetFleet Courier'; }, []);

  return (
    <>
      <section className="bg-[#4E4E50] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-white">
          <span className="text-[#4FC3E0] font-bold uppercase tracking-wider text-sm">Get a Quote</span>
          <h1 className="text-4xl sm:text-5xl font-extrabold mt-2 mb-4">Request your delivery quote</h1>
          <p className="text-gray-200 text-lg max-w-2xl">
            Tell us about your pickup and drop-off and our dispatch team will get right back to you.
            For urgent jobs, call <a href={BRAND.phoneHref} className="text-[#4FC3E0] font-bold underline underline-offset-2">{BRAND.phone}</a>.
          </p>
        </div>
      </section>
      <div className="h-1 bg-gradient-to-r from-[#17A2C4] to-[#4FC3E0]" />

      <section className="py-16 bg-[#f5f7f8]">
        <div className="max-w-2xl mx-auto px-4 sm:px-6">
          <WebForm />
        </div>
      </section>
    </>
  );
}
